import { Block } from '@/components/base/Block'
import { Heading2, Heading4 } from '@/components/base/Heading'
import { Row } from '@/components/base/Layout'
import { useApp } from '@/hooks/useApp'
import { useNavigator } from '@/hooks/useNavigator'
import { align, display } from '@/styles/display'
import spaceStyle from '@/styles/space'
import textAlign from '@/styles/text_align'
import {
  type V1JobPostingSimpleCardsComponent,
  type V1JobPostingCard
} from 'mnvm-mypage-app-ts-if'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Text5 } from '@/components/base/Text'
import Labels from '../Labels'
import HorizontalCarouselComponent from '../ProgressDateComponent/HorizontalCarouselComponent'

interface Props {
  component?: V1JobPostingSimpleCardsComponent
}

const JobPostingOfferAcceptanceCardComponent = (
  props: V1JobPostingCard
): JSX.Element => {
  const app = useApp()
  const nav = useNavigator()
  return (
    <Block
      width={'261px'}
      height={'234px'}
      display={display.FLEX}
      alignItems={align.FLEX_START}
      textAlign={align.LEFT}
      border
      borderRadius={{ all: spaceStyle.XS }}
      margin={{
        right: spaceStyle.S
      }}
      padding={{
        horizontal: spaceStyle.S,
        vertical: spaceStyle.M
      }}
      style={{ boxSizing: 'border-box', flexDirection: 'column', gap: 8 }}
      onClick={() => {
        if (props.id != null) void nav?.gotoJobPostingOfferAcceptance(props.id)
      }}
    >
      <Labels
        padding={{ vertical: spaceStyle.NONE }}
        items={props.labels ?? []}
      ></Labels>
      <Block height={'64px'} textAlign={textAlign.LEFT}>
        <Heading4
          fixedSPfontSize
          textColor={app.theme.mainTextColor}
          margin={{ horizontal: spaceStyle.NONE }}
          maxLines={4}
        >
          {props.body}
        </Heading4>
      </Block>

      <Block height={'33px'} textAlign={textAlign.LEFT}>
        <Heading4
          fixedSPfontSize
          textColor={app.theme.mainTextColor}
          margin={{ horizontal: spaceStyle.NONE }}
          maxLines={1}
        >
          {props.companyName}
        </Heading4>
        <Heading4
          fixedSPfontSize
          textColor={app.theme.mainTextColor}
          margin={{ horizontal: spaceStyle.NONE }}
          maxLines={1}
        >
          {props.title}
        </Heading4>
      </Block>

      <Text5
        textColor={app.theme.mainTextColor}
        margin={{ horizontal: spaceStyle.NONE }}
        maxLines={1}
      >
        {`求人番号： ${props.uuid ?? ''}`}
      </Text5>

      <Text5
        textColor={app.theme.mainTextColor}
        margin={{ horizontal: spaceStyle.NONE }}
        maxLines={1}
      >
        {`回答期限：${props.expireDate ?? ''}`}
      </Text5>

      <Text5
        textColor={app.theme.redColor}
        margin={{ horizontal: spaceStyle.NONE }}
        maxLines={1}
      >
        {`${props.additionalNote ?? ''}`}
      </Text5>
    </Block>
  )
}

const JobPostingOfferAcceptanceComponent = ({
  component
}: Props): JSX.Element => {
  // const nav = useNavigator()
  const gap = 8

  const items = component?.jobPostingCards ?? []
  const itemWidth = 261
  const maxWidthOfItem = items.length * itemWidth + (items.length - 1) * gap

  const infinite = window.innerWidth < maxWidthOfItem

  return (
    <Block id={component?.id} margin={{ bottom: spaceStyle.M }}>
      <Row gutter={gap} justify={align.SPACE_BETWEEN}>
        <Heading2 fixedSPfontSize textAlign={textAlign.LEFT}>
          {component?.title ?? ''}
        </Heading2>
      </Row>
      <HorizontalCarouselComponent
        settings={{ infinite: false, swipe: infinite }}
        itemWidth={itemWidth}
        itemGap={gap}
        itemsLength={items.length}
      >
        {items.map((item) => (
          <div key={item.id}>
            <JobPostingOfferAcceptanceCardComponent {...item} />
          </div>
        ))}
      </HorizontalCarouselComponent>
    </Block>
  )
}

export default JobPostingOfferAcceptanceComponent
